import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Layout as AntLayout } from 'antd';
import Header from '../../components/Header';
import Sidebar from '../../components/Sidebar';
import './index.css';

const { Content } = AntLayout;

const Layout = () => {
  const [collapsed, setCollapsed] = useState(false);

  const handleToggle = () => {
    setCollapsed(!collapsed);
  };

  return (
    <div className={`app-layout ${collapsed ? 'collapsed' : ''}`}>
      <Sidebar collapsed={collapsed} />
      <div className="app-main">
        <Header collapsed={collapsed} onToggle={handleToggle} />
        <Content className="app-content">
          <Outlet />
        </Content>
      </div>
    </div>
  );
};

export default Layout;
